import Constants from '@/utils/Constants'
import {
  SiteApi,
  LoginApi,
  LogoutApi,
  PasswordApi,
  UserApi,
  BookmarkApi,
  ReservationApi,
  NoticeApi,
  CategoryGroupApi,
  ProductCategoryApi,
  ProductGroupApi,
  ProductSearchApi,
  ShopGroupApi,
  MemberGroupApi,
  AnalyzeApi,
  ResultApi,
  HistoryApi,
  ProductAttributeApi,
  ContractApi,
  ItemSearchApi,
  ShopSearchApi,
  DepartmentApi,
  MakerApi,
  SupplierApi,
  ShopAreaApi,
  DashboardApi,
  ManualApi,
  AccessListApi,
  AnalyzeDetailApi,
  AnalyzeMasterApi
} from '../api'
import globalAxios from 'axios'
import redirectErrorPage from '../utils/redirectErrorPage'
import Vue from 'vue'
import { getApp, deleteApp, getApps } from 'firebase/app'
import router from '@/router'

let openApiOption = {
  //  CORSのためdevはproxyで取得していたが、現在はserver側に許可してもらっている
  basePath: Constants['apiEndPoint'],
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*'
  }
  // transformRequest: [function (data, headers) {
  //   // Do whatever you want to transform the data

  //   return data;
  // }],
  // transformResponse: [function (data) {
  //   // Do whatever you want to transform the data

  //   return data;
  // }]
}

let openApiClients = {}

let globalVue = null
export default {
  init: (vue) => {
    globalVue = vue
    let axios = globalAxios
    // axios.defaults.headers.get['Pragma'] = 'no-cache'
    // axios.defaults.headers.get['Cache-Control'] = 'no-cache、no-store'

    openApiOption.basePath = Constants['apiEndPoint']
    openApiClients = {
      'Site': new SiteApi(openApiOption),
      'Login': new LoginApi(openApiOption),
      'Logout': new LogoutApi(openApiOption),
      'Reservation': new ReservationApi(openApiOption),
      'Bookmark': new BookmarkApi(openApiOption),
      'Notice': new NoticeApi(openApiOption),
      'Password': new PasswordApi(openApiOption),
      'User': new UserApi(openApiOption),
      'History': new HistoryApi(openApiOption),
      'Result': new ResultApi(openApiOption),
      'CategoryGroup': new CategoryGroupApi(openApiOption),
      'Contract': new ContractApi(openApiOption),
      'Department': new DepartmentApi(openApiOption),
      'ProductAttribute': new ProductAttributeApi(openApiOption),
      'ProductCategory': new ProductCategoryApi(openApiOption),
      'ProductGroup': new ProductGroupApi(openApiOption),
      'ProductSearch': new ProductSearchApi(openApiOption),
      'ShopGroup': new ShopGroupApi(openApiOption),
      'MemberGroup': new MemberGroupApi(openApiOption),
      'Analyze': new AnalyzeApi(openApiOption),
      'ItemSearch': new ItemSearchApi(openApiOption),
      'ShopSearch': new ShopSearchApi(openApiOption),
      'Maker': new MakerApi(openApiOption),
      'Supplier': new SupplierApi(openApiOption),
      'ShopArea': new ShopAreaApi(openApiOption),
      'Dashboard': new DashboardApi(openApiOption),
      'Manual': new ManualApi(openApiOption),
      'AccessHistory': new AccessListApi(openApiOption),
      'AnalyzeDetail': new AnalyzeDetailApi(openApiOption),
      'AnalyzeMaster': new AnalyzeMasterApi(openApiOption)
    }

    axios.interceptors.request.use(
      function (config) {
        const token = Vue.localStorage.get('token')
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token
          config.headers['SsLocalSession'] = Constants.getUser('session')
        }
        console.log('req:', config.url, config)
        return config
      },
      function (error) {
        console.log('req:err:', error)
        return Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      function (response) {
        const url = response.config.url
        console.log('res:', url, response)
        if (url.indexOf('/site') === -1 && url.indexOf('/notice/public') === -1 &&
          url.indexOf('/password/input') === -1 &&
          url.indexOf('/auth/refresh_token') === -1 && url.indexOf('/logout') === -1) {
          if (response.data.meta) {
            globalVue.$store.dispatch('account/inspectToken', response.data.meta.server_time)
          } else {
            // DLの場合トークン検測を行わない
          }
        }
        // response.data.code = 400200
        // 営業時間外の処理
        if (response.data.code === 400100) {
          redirectErrorPage('営業時間外です。', response.data.code)
          // 同時ログインによるログアウトの処理
        } else if (response.data.code === 400200) {
          redirectErrorPage('同時ログインを検知しました。', response.data.code)
          // 権限不足の処理
        } else if (response.data.code === 400300) {
          redirectErrorPage('権限エラーです。', response.data.code)
          // 権限不足（分析履歴参照権限不足）の処理
        } else if (response.data.code === 400301) {
          console.log('権限不足（分析履歴参照権限不足）')
          globalVue.$store.dispatch('routerdata/setApiMessage', '権限がありません。')
          router.push({ path: '/history' })
          return response
        } else if (response.data.code === 400302) {
          // 多要素認証せずに機能をアクセスする場合
          redirectErrorPage('認証エラーです。', response.data.code)
        } else {
          return response
        }
      },
      function (error) {
        try {
          console.log('res:err:', error)
          if (error && error.response) {
            // 認証エラー時の処理
            if (error.response.status === 401) {
              if (getApps().length > 0) {
                try {
                  const app = getApp()
                  deleteApp(app)
                } catch (e) {
                  console.log('firebase delete fail: ' + e)
                }
              }
              Vue.localStorage.remove('token')
              router.push({ path: '/login' })
              // 権限なし時の処理
            } else if (error.response.status === 403) {
              redirectErrorPage('Error', error.response.status)
              // システムエラー時の処理
            } else if (error.response.status === 500) {
              const _url = error.response.config.url
              if (_url.indexOf('/result/csv') === -1 && _url.indexOf('/result/excel') === -1) {
                redirectErrorPage('Error', error.response.status)
              }
              // ログインの後勝ちの処理
            } else if (error.response.status === 300) {
              redirectErrorPage('Error', error.response.status)
            } else {
              redirectErrorPage('Error', error.response.status)
            }
          }
          return Promise.reject(error)
        } finally {
          globalVue.g_loadingInit()
        }
      }
    )
  },
  request: (types) => {
    return openApiClients[types]
  },
  requestMock: (method, page = null) => {
    let mockapi
    if (page !== null) {
      console.log('mock:req:', '../../test/mock/' + method + '_' + page)
      mockapi = require('../../test/mock/' + method + '_' + page).default.mock
    } else {
      console.log('mock:req:', '../../test/mock/' + method)
      mockapi = require('../../test/mock/' + method).default.mock
    }

    return new Promise(function (resolve, reject) {
      setTimeout(() => {
        console.log('mock:res:', mockapi)
        resolve(mockapi)
      }, 2000)
    })
  }
}
